module.exports = __webpack_public_path__ + "img/img17.6d88b3ec.png";